module.exports = __webpack_public_path__ + "img/XAS.d093b984.svg";